import { FC } from "react";
import { PlaceholderProps } from "react-select";
import classNames from "classnames";
import styles from "./styles.module.scss";
import { OptionItem } from "../../OptionItem";

/**
 * The placeholder text component.
 */
export const Placeholder: FC<PlaceholderProps<OptionItem | null>> = (props) => {
  const { children, innerProps } = props;

  const placeholderClassName = classNames(styles.Placeholder, "placeholder");

  return (
    <div {...innerProps} className={placeholderClassName}>
      {children || <>&nbsp;</>}
    </div>
  );
};
